import app_img from '@/public/article/App.webp';
import article1 from '@/public/article/picture.webp';
import route_img from '@/public/article/Route Optimization.webp';
import main_bg from '@/public/industries/property_maintenance/main.webp';
import schedule_img from '@/public/industries/property_maintenance/Manage Your Staff Efficiently.webp';
import managment_img from '@/public/industries/property_maintenance/Optimize Your Work Order Process.webp';
import invoicing from '@/public/industries/property_maintenance/Utilize the Potential of Data.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const faq = [
  {
    title: 'What is Property Maintenance Tracking Software?',
    text: `It's a cloud-based solution that helps you coordinate all aspects of your property maintenance, from request management to work assignment, billing, and tracking. Try our demo now!`,
  },
  {
    title: 'What Does Orcatec`s Property Management Maintenance Software Cost?',
    text: `We have flexible pricing packages depending on your needs. You can get started for free — all the basic features are available in the free version. Additional modules are available for $19/month.`,
  },
  {
    title:
      'What Types of Properties Can Benefit From Using Property Management Maintenance Software?',
    text: 'Our solution is suitable for all types of properties: apartments, houses, offices, shopping centers, warehouses, and more. It is scalable to manage portfolios of any size.',
  },
  {
    title: 'Why Use Property Management Software for Small Businesses?',
    text: `Automation will speed up your processes, reduce costs, and allow you to focus on customer service. It's the best way to prepare for business expansion.`,
  },
  {
    title: 'What is the Best Property Maintenance Software?',
    text: `Try Orcatec — award-winning and used by industry leaders. Try it for free now!`,
  },
];

const testimonals = [
  {
    text: `"The introduction of Orcatec's home maintenance management software was a game changer for our business. Their intuitive tools and responsive support have played a key role in our growth."`,
    name: 'Mark,',
    position: 'KeyGuard Locksmith Network',
  },

  {
    text: `"Integrating Orcatec into our day-to-day operations has measurably increased customer satisfaction and repeat business."`,
    name: 'Kelly,',
    position: 'VoltEdge Electrical Solutions',
  },
  {
    text: `"Since we started using Orcatec, our administrative staff workload has been cut in half, allowing us to focus on the field instead of paperwork."`,
    name: 'Alex,',
    position: 'Apex Garage Door Services',
  },

  {
    text: `"The introduction of Orcatec's home maintenance management software was a game changer for our business. Their intuitive tools and responsive support have played a key role in our growth."`,
    name: 'Mark,',
    position: 'KeyGuard Locksmith Network',
  },

  {
    text: `"Integrating Orcatec into our day-to-day operations has measurably increased customer satisfaction and repeat business."`,
    name: 'Kelly,',
    position: 'VoltEdge Electrical Solutions',
  },
  {
    text: `"Since we started using Orcatec, our administrative staff workload has been cut in half, allowing us to focus on the field instead of paperwork."`,
    name: 'Alex,',
    position: 'Apex Garage Door Services',
  },
];

const industries = {
  title: 'Our Industries',
  description: `Orcatec serves a diverse range of sectors within the property maintenance landscape. From residential complexes to commercial estates, our property management software for maintenance is engineered to meet the unique challenges of various industries.
  `,
  items: [
    { title: 'HVAC', path: IRoutePath.INDUSTRIES_HVAC },
    { title: 'Plumbing', path: IRoutePath.INDUSTRIES_PLUMBING },
    { title: 'Appliance Repair', path: IRoutePath.INDUSTRIES_APPLIANCE },
    { title: 'Electrician', path: IRoutePath.INDUSTRIES_ELECTRICIAN },
    { title: 'Garage Door', path: IRoutePath.INDUSTRIES_GARAGE_DOOR },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Handyman',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Landscaping and Lawn',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Home Renovation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Automotive',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pest Control',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Window Cleaning',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Carpet Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pool and Spa Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fireplace and Chimney',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Roofing',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Water Treatment',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Alarm and Security',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Irrigation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Painting Contractors',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fire Safety',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Computer Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Moving',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Air Duct Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Remodeling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Janitorial Services',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Excavation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Demolition Contractor',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tree Care',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Restoration',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Flooring',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tiling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Drywall',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pressure Washing',
      path: IRoutePath.INDUSTRIES,
    },
  ],
};

const articles = {
  title: `Software Features Made for Appliance Repair Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_img,
        alt: 'Scheduling & Dispatch',
      },
      href: '#',
      tag: 'Scheduling & Dispatch',
      title: 'Manage Your Staff Efficiently',
      text: `Ensure your maintenance team is at the right place at the right time with our advanced scheduling and dispatch feature.`,
      list: [
        {
          text: 'Effortlessly schedule appointments with an intuitive calendar that avoids conflicts and optimizes routes.',
        },
        {
          text: 'Quickly dispatch maintenance staff to urgent jobs, adjusting schedules dynamically as new requests come in.',
        },
        {
          text: 'Keep track of staff availability, qualifications, and workload to make informed dispatch decisions.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: managment_img,
        alt: 'Work Order Management',
      },
      href: '#',
      tag: 'Work Order Management',
      title: 'Optimize Your Work Order Process',
      text: `Keep your maintenance tasks organized and ensure they are completed efficiently with our work order management feature.`,
      list: [
        {
          text: 'With just a few clicks, assign tasks to staff or vendors, including all the details they need to complete the job well.',
        },
        {
          text: 'Receive updates as tasks progress, from initial assignment to completion, keeping everyone in the loop.',
        },
        {
          text: 'You can access a history of all maintenance activities for each property, which is essential for tracking and planning future work.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: invoicing,
        alt: 'Analytics',
      },
      href: '#',
      tag: 'Analytics',
      title: 'Utilize the Potential of Data',
      text: `Access valuable information and utilize data-driven strategies to enhance the efficiency of your property maintenance business through Orcatec's extensive reporting and analytics platform.`,

      list: [
        {
          text: 'Gain immediate understanding through interactive dashboards that visually depict important metrics.',
        },
        {
          text: 'Monitor patterns over time to detect trends, evaluate progress towards objectives, and evaluate the impact of implemented strategies.',
        },
        {
          text: 'Convert data into practical insights that empower you to enhance resource allocation.',
        },
      ],
    },
    {
      type: ArticleType.VERICAL,
      image: {
        path: route_img,
        alt: 'Route Optimization',
      },
      href: '#',
      tag: 'Route Optimization',
      title: 'Optimize the Route With AI',
      text: `AI-based route optimization utilizes data on traffic conditions, and technician locations to create the most efficient travel routes. This method significantly reduces travel time and minimizes fuel usage.`,
      list: [
        { text: 'Provision of real-time updates on job status and changes' },
        {
          text: 'Mobile access to job information and schedules',
        },
        { text: 'Immediate communication and collaboration tools' },
      ],
    },
  ],
};

const intro = {
  imageSrc: main_bg,
  tag: 'Property Management Maintenance Software',
  title: {
    first_part: 'Transform Your Property Management Maintenance Business with',
    second_part: 'Orcatec',
  },
  description: `With our software for property maintenance companies, you can effortlessly coordinate repairs, track maintenance costs, and ensure compliance with housing regulations, all from a single platform. Our software is built to save you time and reduce costs, enabling you to focus on enhancing tenant satisfaction and property value.`,
  info: [
    { title: '50%', description: 'Decrease in Unplanned Repairs' },
    { title: '95%', description: 'User Satisfaction Rate' },
  ],
};

const fullArticle1 = {
  image: {
    path: article1,
    alt: 'What is Free Property Maintenance Software?',
  },
  title: 'What is Free Property Maintenance Software?',
  description: `The maintenance software for property management offers a no-cost digital solution for property managers and landlords to oversee and execute the upkeep of their properties. This software streamlines the maintenance process, providing essential tools to handle service requests, schedule work, and monitor activities without any financial investment. Key features include:`,
  item: [
    {
      title: 'Work Order Processing',
      description:
        'Streamlines creation, assignment, and tracking of work orders, providing clear communication channels between property managers, maintenance staff, and tenants.',
    },
    {
      title: 'Expense Tracking',
      description:
        'Keeps a detailed log of maintenance-related expenses, aiding in budget management and financial planning.',
    },
    {
      title: 'Compliance and Reporting',
      description:
        'Assists in maintaining property standards according to regulatory requirements, with features for documentation and report generation to ensure compliance.',
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_img,
    alt: 'Why Property Maintenance Contractors Choosing Orcatec?',
  },
  title: 'Why Property Maintenance Contractors Choosing Orcatec?',
  description: `Orcatec's software platform stands out as the go-to choice for property maintenance contractors due to its dedication to providing accessible, scalable, and adaptable tools that cater to the industry's evolving needs:`,
  item: [
    {
      title: '',
      description: `Access essential software features without any initial financial commitment, allowing you to evaluate the software's impact on your business with a comprehensive free starter package.`,
    },
    {
      title: '',
      description:
        'Enjoy the freedom to select and pay for only the functionalities that align with your specific needs, ensuring cost-effectiveness and a personalized software experience.',
    },
    {
      title: '',
      description: `Tailor the software to your unique business requirements with easy customization options, including custom forms, workflows, and reporting.`,
    },
    {
      title: '',
      description: `Manage business operations from any device, whether it's a PC, tablet, or mobile phone, for enhanced convenience and efficiency. Orcatec's platform is built to be as mobile as your team.`,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Dive into a world of expert insights, tips, and the latest trends in the property maintenance industry. Our blog is your go-to resource for thought leadership, practical advice, and innovative strategies designed to help you stay ahead of the curve.`,
};

const bookDemo = {
  title: 'Book a Free Demo',
  description: `Ready to take control of your property maintenance management software with a solution that understands the breadth of your needs? Orcatec is more than software—it's a partnership for your business's future. Connect with us to discuss how we can support your unique property management journey. `,
};

export {
  reviews,
  fullArticle2,
  fullArticle1,
  intro,
  articles,
  industries,
  testimonals,
  faq,
  blog,
  bookDemo,
};
